export const SET_INVOLVED_PARTIES = 'involvedParties/SET_INVOLVED_PARTIES';
export const SET_SEARCH_DETAILS = 'involvedParties/SET_SEARCH_DETAILS';
export const SET_SELECTED_CUST = 'involvedParties/SET_SELECTED_CUST';
export const SET_ROLE_TYPES = 'involvedParties/SET_ROLE_TYPES';
export const SET_BP_TYPES = 'involvedParties/SET_BP_TYPES';
export const SET_TITLES = 'involvedParties/SET_TITLES';
export const SET_BP_COUNTRY = 'involvedParties/SET_BP_COUNTRY';
export const SET_STATE = 'involvedParties/SET_STATE';
export const SET_CIPVERIFICATIONTYPES = 'involvedParties/SET_CIPVERIFICATIONTYPES';
export const SET_STATEOFISSUANCE = 'involvedParties/SET_STATEOFISSUANCE';
export const SET_FEEDAGENCYOFISSUANCE = 'involvedParties/SET_FEEDAGENCYOFISSUANCE';
export const SET_MLTRYAGENCYOFISSUANCE = 'involvedParties/SET_MLTRYAGENCYOFISSUANCE';
export const SET_INVOLVED_PARTIES_ERROR = 'involvedParties/SET_INVOLVED_PARTIES_ERROR';
